import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
//---------------------------------------------------------------------------------
import { jsonParseTraslation } from 'utils/getTranslation';
import { NotFoundSearchResults } from '../NotFoundSearchResults';

export const ErrorMessage = ({ value }) => {
  const { notFoundResults, popular, contenidos } = useSelector(
    state => state.search.searchResults,
  );
  const texts = useSelector(state => state.metadata.translations);
  const textPopular =
    jsonParseTraslation(texts)?.popularSearches_default_title_label || '';

  return (
    <Fragment>
      {value.length >= 1 && notFoundResults?.type === 'searchResults' && (
        <Fragment>
          {notFoundResults?.type === 'searchResults' && (
            <NotFoundSearchResults value={value} />
          )}
          <h2 className="search-results__title not-found">{textPopular}</h2>
        </Fragment>
      )}
      {value.length >= 1 &&
        notFoundResults?.type === 'searchResults' &&
        popular?.length < 1 &&
        contenidos?.length < 1 && (
          <NotFoundSearchResults
            value={value}
            doubleError={popular?.length < 1 && contenidos?.length < 1}
          />
        )}
      {value.length >= 1 && notFoundResults?.type === 'failureService' && (
        <NotFoundSearchResults value={value} withoutEnclosure={true} />
      )}
      {value.length === 0 && notFoundResults?.type === 'failureService' && (
        <NotFoundSearchResults value={value} withoutEnclosure={true} />
      )}
    </Fragment>
  );
};

ErrorMessage.propTypes = {
  value: PropTypes.string.isRequired,
};
